<template>
    <div class="contract-rent-edit">
        <el-form
            ref="ruleForm2"
            label-position="top"
            size='small'
            :model="form"
            :rules="rules">
            <div>
                <div class="font-medium flex items-center border-b border-gray-200 dark:border-dark-5 pb-5">
                    <ChevronDownIcon class="w-4 h-4 mr-2" /> 合同信息
                </div>
                <div class="grid grid-cols-12 mt-5">
                    <div class="col-span-6 pr-10">
                        <el-form-item label="资产地址明细：" prop="assetAddressDetail">
                            <el-input v-model="form.assetAddressDetail" placeholder="请输入地址" />
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="房屋建筑面积(㎡)：" prop="buildingArea">
                            <el-input v-model="form.buildingArea" placeholder="请输入面积" />
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="土地面积(㎡)：" prop="">
                            <el-input v-model="form.landArea" placeholder='请输入面积'/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="招租方式：" prop="rentingMethod">
                            <el-select style='width: 100%;' v-model="form.rentingMethod" placeholder="请选择">
                                <el-option v-for="item in hireTypeOptions" :value="item.value" :label="item.key" :key="item.value">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="承租人或使用人：" prop="lessee">
                            <el-input :disabled='disableFlag' v-model="form.lessee" placeholder="请输入正确的承租人名称"/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="租客类型：" prop="tenantType">
                            <el-select style='width: 100%;' :disabled='disableFlag' v-model="form.tenantType" placeholder="请选择">
                                <el-option v-for="item in rentTypeOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <div class="col-span-6 pr-10">
                        <el-form-item label="土地当前使用状态：" prop="">
                            <el-select style='width: 100%;' v-model="form.landUseStatus" placeholder="请选择">
                                <el-option v-for="item in landStatusOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="房屋当前使用状态：" prop="">
                            <el-select style='width: 100%;' v-model="form.houseUseStatus" placeholder="请选择">
                                <el-option v-for="item in landStatusOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="是否转租：" prop="">
                            <el-select style='width: 100%;' v-model="form.whetherSublease" placeholder="请选择">
                                <el-option v-for="item in reformOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="存在免租期：" prop="">
                            <el-select style='width: 100%;' v-model="form.rentFreePeriod" placeholder="请选择">
                                <el-option v-for="item in reformOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10 line-height-set">
                        <el-form-item label="承租人或使用人是否改制企业：" prop="">
                            <el-select style='width: 100%;' v-model="form.reformedEnterprise" placeholder="请选择">
                                <el-option v-for="item in reformOptions" :value="item.value" :key="item.key" :label="item.key">
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="合同编号：" prop="">
                            <el-input v-model="form.contractNo" placeholder="请输入合同编号" />
                        </el-form-item>
                    </div>
                </div>
                <!-- 租金信息 -->
                <div class="font-medium flex items-center border-b border-gray-200 dark:border-dark-5 pb-5 mt-5">
                    <ChevronDownIcon class="w-4 h-4 mr-2" /> 租金信息
                </div>
                <div class="grid grid-cols-12 mt-5">
                    <div class="col-span-6 pr-10">
                        <el-form-item label="合同开始日期：" prop="contractStartDate">
                            <el-date-picker type='date' :disabled='disableFlag' v-model="form.contractStartDate" placeholder='请选择' value-format='yyyy/MM/dd'></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="合同结束日期：" prop="contractEndDate">
                            <el-date-picker type='date' :disabled='disableFlag' v-model="form.contractEndDate" placeholder='请选择' value-format='yyyy/MM/dd'></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="租赁期限(月)：" prop="leaseTerm">
                            <el-input :disabled='disableFlag' v-model="form.leaseTerm" placeholder='请输入租赁期限'/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="押金(元)：" prop="">
                            <el-input v-model="form.deposit" placeholder='请输入押金'/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="租金收取间隔：" prop="rentCollectionInterval">
                            <el-select style='width: 100%;' :disabled='disableFlag' v-model="form.rentCollectionInterval" placeholder="请选择">
                                <el-option v-for="item in intervalOptions" :value="item.value" :key="item.key" :label='item.key'>
                                    {{item.key}}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="当期合同年租金(元)：" prop="annualContractRent">
                            <el-input :disabled='disableFlag' v-model="form.annualContractRent" placeholder="请输入金额"/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="日租金单价(元)：" prop="">
                            <el-input :disabled='disableFlag' v-model="form.dailyRentalUnitPrice" placeholder='请输入日租金单价'/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="评估价(元)：" prop="">
                            <el-input :disabled='disableFlag' v-model="form.evaluatePrice" placeholder='请输入日租金单价'/>
                        </el-form-item>
                    </div>
                    <div class="col-span-6 pr-10">
                        <el-form-item label="历史已收缴租金(元)：" prop="">
                            <el-input :disabled='disableFlag' v-model="form.historyReceived" placeholder='请输入日租金单价'/>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
export default {
    name:'contractAndRentEdit',
    data(){
        let checkLeaseTerm=(rule,value,callback)=>{
            if (!value) {
                return callback(new Error('请输入租赁期限'));
            }else{
                let reg=/^[0-9]+$/
                if(!reg.test(value)){
                    return callback(new Error('请输入正确的租赁期限'));
                }
                callback();
            }
        }
        return{
            disableFlag:false,
            form:{
                assetAddressDetail:'',
                buildingArea:'',
                landArea:'',
                rentingMethod:'',
                lessee:'',
                tenantType:'',
                landUseStatus:'',
                houseUseStatus:'',
                whetherSublease:'',
                rentFreePeriod:'',
                reformedEnterprise:'',
                contractStartDate:'',
                contractEndDate:'',
                leaseTerm:'',
                deposit:'',
                rentCollectionInterval:'',
                annualContractRent:'',
                dailyRentalUnitPrice:'',
                contractNo:'',
            },
            rules: {
                assetAddressDetail: [
                    { required: true, message: '请输入资产地址明细', trigger: 'blur' },
                ],
                buildingArea: [
                    { required: true, message: '请输入面积', trigger: 'blur' },
                ],
                rentingMethod:[
                    { required: true, message: '请选择招租方式', trigger: 'change' }
                ],
                lessee:[
                    { required: true, message: '请输入承租人或使用人', trigger: 'blur' },
                ],
                tenantType:[
                    { required: true, message: '请选择租客类型', trigger: 'change' }
                ],
                contractStartDate:[
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
                contractEndDate:[
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
                leaseTerm:[
                    { required: true,validator:checkLeaseTerm, trigger: 'blur' },
                ],
                rentCollectionInterval:[
                    { required: true, message: '请选择租金收取间隔', trigger: 'change' }
                ],
                annualContractRent:[
                    { required: true, message: '请输入当期合同年租金', trigger: 'blur' },
                ],
            },
            hireTypeOptions:[
                {value:'',key:'请选择'},
                {value:'PLATFORM',key:'平台'},
                {value:'AGREEMENT',key:'协议'},
                {value:'OTHER',key:'其他'},
            ],
            reformOptions:[
                {value:'',key:'请选择'},
                {value:'1',key:'是'},
                {value:'0',key:'否'},
            ],
            landStatusOptions:[
                {value:'',key:'请选择'},
                {value:'LEASE',key:'出租'},
                {value:'FREE',key:'无偿'},
                {value:'VACANT',key:'空置'},
                {value:'SELF_USE',key:'自用'},
            ],
            intervalOptions:[
                {value:'',key:'请选择'},
                {value:'MONTH',key:'月'},
                {value:'SEASON',key:'季'},
                {value:'HALF_A_YEAR',key:'半年'},
                {value:'ONE_YEAR',key:'一年'},
            ],
            rentTypeOptions:[
                {value:'',key:'请选择'},
                {value:'ENTERPRISE',key:'企业'},
                {value:'PERSONAL',key:'个人'},
            ],
        }
    },
    methods:{
    },
    created(){
        // this.disableFlag= this.$route.query.operation==='edit';
    }
}
</script>


